export const partsData = {
    "RGBXH": "Dreamstation HH  - RGBXH",
    "R100627C": "Dreamstation cellular modem  - R100627C",
    "1122520": "Dreamstation HH chamber - 1122520",
    "1120617": "Dreamstation HH flip lid seal  - 1120617",
    "1122446": "Dreamstation reusable filter - 1122446",
    "1122518": "Dreamstation disposable ultra fine filters 2 pack  - 1122518",
    "1122519": "Dreamstation disposable ultra fine filter 6 pack  - 1122519",
    "PR15": "15mm standard tubing - PR15",
    "HT15": "15mm heated tubing - HT15",
    "1074400": "15mm performance tubing - 1074400",
    "1118499": "Dreamstation Philips, PAP, 80W, Power Supply - 1118499",
    "1039026": "Dreamstation Power lead (plug section)  - 1039026",
    "1146072": "Dreamstation 2 HH water tank no lid - 1146072",
    "1146073": "Dreamstation 2 HH lid only - 1146073",
    "1142832": "Dreamstation 2 HH water tank with lid - 1142832",
    "1142687": "Dreamstation 2 reusable filter  - 1142687",
    "1142829​ ": "Dreamstation 2 disposable ultra fine filter 2 pack - 1142829​ ",
    "1142831​ ": "Dreamstation 2 disposable ultra fine filter 6 pack - 1142831​ ",
    "1133375": "Dreamwear Full face mask small - 1133375",
    "1133376": "Dreamwear Full face mask medium - 1133376",
    "1133378": "Dreamwear Full face mask medium wide - 1133378",
    "1133377": "Dreamwear Full face mask large - 1133377",
    "1133400": "Dreamwear Full face fitpack - 1133400",
    "1090602": "Amara View Mask small - 1090602",
    "1090603": "Amara View Mask medium - 1090603",
    "1090604": "Amara View Mask Large - 1090604",
    "1090420": "Amara Gell Mask Petite - 1090420",
    "1090421": "Amara Gell mask small - 1090421",
    "1090425": "Amara Gell mask Medium - 1090425",
    "1090426": "Amara Gel Mask large - 1090426",
    "1060803": "Fitlife Mask small - 1060803",
    "1060804": "Fitlife Mask Large - 1060804",
    "1089994": "Fitlife Mask Extra Large - 1089994",
    "1133430": "Dreamwear full face small cushion - 1133430",
    "1133431": "Dreamwear full face medium cushion - 1133431",
    "1133433": "Dreamwear full face medium wide cushion - 1133433",
    "1133432": "Dreamwear full face large cushion - 1133432",
    "1090692": "Amara View small cushion - 1090692",
    "1090693": "Amara View medium cushion - 1090693",
    "1090694": "Amara View large cushion - 1090694",
    "1090490": "Amara Gel petite cushion - 1090490",
    "1090492": "Amara Gel small cushion - 1090492",
    "1090493": "Amara Gell medium cushion - 1090493",
    "1090494": "Amara Gel large cushion - 1090494",
    "1116748": "Dreamwear full face swivel and elbow - 1116748",
    "1133450": "Dreamwear full face headgear - 1133450",
    "1133454": "Dreamwear full face magnetic clips - 1133454",
    "1116745": "Dreamwear full face small frame - 1116745",
    "1116746": "Dreamwear full face medium frame - 1116746",
    "1116747": "Dreamwear full face large frame - 1116747",
    "1090689": "Amara View quick release tube - 1090689",
    "1090696": "Amara View large headgear - 1090696",
    "1090697": "Amara View standard headgear - 1090697",
    "1090698": "Amara View headgear clips - 1090698",
    "1136626": "Amara View magnetic clips - 1136626",
    "1090297": "Amara Gel headgear - 1090297",
    "1090296": "Amara Gel reduced size headgear - 1090296",
    "1090698G": "Amara Gel headgear clips  - 1090698",
    "1081899": "Amara Gel swivel - 1081899",
    "1060807": "Fitlife headgear small - 1060807",
    "1060808": "Fitlife headgear large - 1060808",
    "1089990": "Fitlife headgear extra large - 1089990",
    "1060809": "Fitlife EE exhalation elbow - 1060809",
    "7041": "Fitlife swivel - 7041",
    "1060913": "Fitlife snap clips - 1060913",
    "1116700": "Dreamwear nasal mask fitpack - 1116700",
    "1094061": "Wisp Fabric fitpack - 1094061",
    "1094060": "Wisp Silicone fitpack - 1094060",
    "1116740": "Dreamwear nasal small cushion - 1116740",
    "1116741": "Dreamwear nasal medium cushion - 1116741",
    "1116742": "Dreamwear nasal large cushion - 1116742",
    "1116743": "Dreamwear nasal medium wide cushion - 1116743",
    "1094086": "Wisp petite cushion - 1094086",
    "1094087": "Wisp small/medium cushion - 1094087",
    "1094088": "Wisp large cushion - 1094088",
    "1112031": "Wisp extra large cushion - 1112031",
    "1116748N": "Dreamwear nasal swivel and elbow - 1116748",
    "1116751N": "Dreamwear nasal headgear with arms - 1116751",
    "1116745N": "Dreamwear nasal small frame - 1116745",
    "1116746N": "Dreamwear nasal medium frame - 1116746",
    "1116747N": "Dreamwear nasal large frame - 1116747",
    "1116754": "Dreamwear nasal fabric wraps - 1116754",
    "1094082": "Wisp headgear - 1094082",
    "1109307": "Wisp petite headgear - 1109307",
    "1094078": "Wisp large headgear - 1094078",
    "1094080": "Wisp silicone frame - 1094080",
    "1094081": "Wisp fabric frame - 1094081",
    "1120434": "Wisp magnetic headgear clips - 1120434",
    "1094083": "Wisp headgear clips - 1094083",
    "1105624": "Wisp tube and elbow assembly - 1105624",
    "1146468": "Dreamwear silicone pillows fitpack - 1146468",
    "1146472": "Dreamwear silicone pillows small cushion - 1146472",
    "1146473": "Dreamwear silicone pillows medium cushion - 1146473",
    "1146475": "Dreamwear silicone pillows medium wide cushion - 1146475",
    "1146474": "Dreamwear silicone pillows large cushion  - 1146474",
    "1116748P": "Dreamwear silicone pillows swivel and elbow - 1116748",
    "1116751": "Dreamwear silicone pillows headgear with arms - 1116751",
    "1116745P": "Dreamwear silicone pillows small frame - 1116745",
    "1116746P": "Dreamwear silicone pillows medium frame - 1116746",
    "1116747P": "Dreamwear silicone pillows large frame - 1116747",
    "1116754P": "Dreamwear silicone pillows fabric wraps - 1116754",
    "1012911": "Premium chin strap - 1012911",
    "1006085": "Deluxe chin strap - 1006085",
    "1121162": "Dreamstation carry case - 1121162",
    "312710": "O2 entrainment port - 312710",
    "302418": "Pressure valve - 302418",
    "1120746": "Dreamstation 12v power cord  - 1120746",
    "R1126942": "Dreamstation lithium ion battery - R1126942"
};

export const partsDataPL = {
  '100625C': "Rura Standardowa Dream Station 15mm",
  'R100625C': "Rura Podgrzewana Dream Station 15mm",
  'R100723W ': "Rura Mikro elastyczna DreamStation 12mm ",
  'R100226C': "Rura podgrzewana Mikro elastyczna DreamStation 12mm ",
  '1090297': "Rura do maski Amara View",
  '1090698-G': "Poduszka Amara GEL P",
  '1090296': "Poduszka Amara GEL S",
  '1090490': "Poduszka Amara Gel M",
  '1090492': "Poduszka Amara Gel L",
  '1090493': "Poduszka Amara P",
  '1090494': "Poduszka Amara S",
  '1090696': "Poduszka Amara M",
  '1090697': "Poduszka Amara L",
  '1136626': "Poduszka Amara View L",
  '1090698': "Poduszka Amara View M",
  '1090692': "Poduszka Amara View S",
  '1090693': "Poduszka Dream Wear L",
  '1090694': "Poduszka Dream Wear M",
  '1090689': "Poduszka Dream Wear S",
  '1133450': "Poduszka Dream Wear MW",
  '1133454': "Poduszka Dream Wear Full Face S",
  '1133430': "Poduszka Dream Wear Full Face M",
  '1133431': "Poduszka Dream Wear Full Face L",
  '1133433': "Poduszka Dream Wear Full Face MW",
  '1133432': "Poduszka Dream Wear Silicone Pillows S",
  '1116748': "Poduszka Dream Wear Silicone Pillows M",
  '1116745': "Poduszka Dream Wear Silicone Pillows L",
  '1116746': "Poduszka Dream Wear Silicone Pillows MW",
  '1116747': "Poduszka DreamWisp  rozmiar P",
  '1116751': "Poduszka DreamWisp  rozmiar S",
  '1116754': "Poduszka Dream Wisp L",
  '1116750': "Poduszka Dream Wisp M",
  '1146472': "Poduszka Dream Wisp XL",
  '1146473': "Poduszka do maski PICO S/M",
  '1146475': "Poduszka do maski PICO L",
  '1146474': "Poduszka do maski PICO XL",
  '1137964': "Pasy do maski Amara ",
  '1137965': "Pasy do maski Amara Gel ",
  '1120434': "Pasy do maski Amara View ",
  '1137966': "Pasy do maski DreamWear",
  '1060807': "Pasy do maski DreamWear FullFacee",
  '1060808': "Pasy do maski DreamWear Silicone Pillows",
  '1089990': "Pasy do maski PICO",
  '1060809': "Zasilacz DreamStation",
  '7041': "Modem DreamStation"
};